import { setSpreadsDefaultZoomAction as setSpreadsDefaultZoomOperation } from 'editor/src/store/editorModules/panAndZoom/slice';

export default setSpreadsDefaultZoomOperation;
